import React, { useState, useEffect, useCallback, memo } from 'react';
import { Box, Icon, IconButton, Tooltip } from '@material-ui/core';

import useStyles from './styles';

const Search = ({ filterHandler, toggleHandler }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const input = React.useRef(null);

  const handleInputSearch = useCallback(() => {
    filterHandler(input.current.value);
  }, [filterHandler]);

  const handleToggleSearch = useCallback(() => {
    setOpen(oldState => !oldState);
  }, []);

  useEffect(() => {
    if (open) {
      input.current.focus();
    } else {
      input.current.value = '';
      handleInputSearch();
    }
    toggleHandler(open);
  }, [handleInputSearch, open, toggleHandler]);

  return (
    <Box className={`${classes.container} ${open ? 'open' : ''}`}>
      <Tooltip title={!open ? 'Pesquisar' : ''}>
        <IconButton
          classes={{ root: classes.btnIconContainer }}
          onClick={handleToggleSearch}
        >
          <Icon>search</Icon>
        </IconButton>
      </Tooltip>
      <Box className="input-container">
        <input
          className="input"
          type="text"
          ref={input}
          name="search"
          onChange={handleInputSearch}
        />
      </Box>
      <IconButton
        className="btn-close"
        classes={{ root: classes.btnIconContainer }}
        onClick={handleToggleSearch}
      >
        <Icon fontSize="small">close</Icon>
      </IconButton>
    </Box>
  );
};

export default memo(Search);
